import React from 'react';
import {
  Paper,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
  Popper,
  Fade,
} from '@mui/material';
import { Link } from 'react-router-dom';

const SearchResults = ({ results, anchorEl, open, onClose }) => {
  if (!open || results.length === 0) return null;

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      transition
      style={{ zIndex: 1301, width: anchorEl?.offsetWidth }}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Paper
            elevation={3}
            sx={{
              mt: 1,
              maxHeight: '400px',
              overflowY: 'auto',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}
          >
            <List sx={{ py: 0 }}>
              {results.map((result, index) => (
                <ListItem
                  key={index}
                  component={Link}
                  to={result.path}
                  onClick={onClose}
                  sx={{
                    py: 1.5,
                    px: 2,
                    textDecoration: 'none',
                    color: 'inherit',
                    borderBottom: index < results.length - 1 ? '1px solid #f0f0f0' : 'none',
                    '&:hover': {
                      bgcolor: 'rgba(2, 136, 209, 0.04)',
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: '#0288d1',
                        fontWeight: 600,
                        fontSize: '0.95rem',
                        mb: 0.5
                      }}
                    >
                      {result.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#666',
                        fontSize: '0.85rem',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden'
                      }}
                    >
                      {result.excerpt}
                    </Typography>
                  </Box>
                </ListItem>
              ))}
            </List>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};

export default SearchResults; 